import { Grid, Typography } from '@mui/material';
import { usePqrRedirect } from './hook';
import { PqrRedirectProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import DropZoneField from '../../../../../components/general/fields/dropzoneField/index';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Table } from '../../../../../components/general/table';

export const PqrRedirect = (props: PqrRedirectProps) => {
    const {
        formik,
        areas,
        person1,
        person2,
        person3,
        handleOnChange,
        columns,
        rows,
        activeForm,
    } = usePqrRedirect(props);
    if (!activeForm) return null;
    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Redireccionar PQR
                </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(areas)}
                    label="Área encargada"
                    name="area1"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.area1}
                    errors={formik.errors.area1}
                    value={formik.values.area1}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('area1', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(person1)}
                    label="Persona encargada"
                    name="person1"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.person1}
                    errors={formik.errors.person1}
                    value={formik.values.person1}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('person1', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Email"
                    name="email1"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.email1}
                    errors={formik.errors.email1}
                    value={formik.values.email1}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(areas)}
                    label="Área encargada"
                    name="area2"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.area2}
                    errors={formik.errors.area2}
                    value={formik.values.area2}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('area2', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(person2)}
                    label="Persona encargada"
                    name="person2"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.person2}
                    errors={formik.errors.person2}
                    value={formik.values.person2}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('person2', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Email"
                    name="email2"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.email2}
                    errors={formik.errors.email2}
                    value={formik.values.email2}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(areas)}
                    label="Área encargada"
                    name="area3"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.area3}
                    errors={formik.errors.area3}
                    value={formik.values.area3}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('area3', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(person3)}
                    label="Persona encargada"
                    name="person3"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.person3}
                    errors={formik.errors.person3}
                    value={formik.values.person3}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('person3', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Email"
                    name="email3"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.email3}
                    errors={formik.errors.email3}
                    value={formik.values.email3}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="¿Redireccionar PQR?"
                    checked={Boolean(formik.values.redirectPqr)}
                    onChange={() => {
                        formik.setFieldValue(
                            'redirectPqr',
                            !formik.values.redirectPqr
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="¿Generar alerta?"
                    checked={Boolean(formik.values.generateAlert)}
                    onChange={() => {
                        formik.setFieldValue(
                            'generateAlert',
                            !formik.values.generateAlert
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="¿Agregar anexo?"
                    checked={Boolean(formik.values.addAnnex)}
                    onChange={() => {
                        formik.setFieldValue(
                            'addAnnex',
                            !formik.values.addAnnex
                        );
                    }}
                    disabled={rows && rows.length > 0}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            {formik.values.addAnnex && (
                <>
                    <Grid item xs={12}>
                        <DropZoneField
                            name="attachments"
                            title="Suelte los archivos aquí o haga click para subir (El tamaño máximo no debe superar 30MB)"
                            subtitle={null}
                            subtitle2={null}
                            maxFileSize={30 * 1024 * 1024}
                            onChange={handleOnChange}
                        >
                            <CloudUploadIcon fontSize="large" color="warning" />
                        </DropZoneField>
                    </Grid>
                    {rows && rows.length > 0 && (
                        <Grid item xs={12}>
                            <Table
                                columns={columns}
                                rows={rows}
                                rowCount={rows.length}
                                pageSizeOptions={[10, 20, 50]}
                                disableRowSelectionOnClick
                            />
                        </Grid>
                    )}
                </>
            )}
        </Grid>
    );
};
